import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ProductImportIconSvg from './icon-product-import.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ProductImportIconSvg {...validProps} />;
}
SvgComponent.iconName = 'productImportIcon';

export const ProductImportIcon = svgIconWrapper(SvgComponent);
